import { FC, useMemo } from 'react'
import clsx from 'clsx'

import { useAuth } from 'store/auth/useAuth'

import { formatTime, getPercent } from '../utils'

import commonStyle from '../audio-player.module.scss'
import style from './progress-bar.module.scss'

interface IProgressBar {
  audioRef: React.RefObject<HTMLAudioElement>
  progressBarRef: React.RefObject<HTMLInputElement>
  duration: number
  timeProgress: number
  setTimeProgress: (t: number) => void
}

const ProgressBar: FC<IProgressBar> = ({
  progressBarRef,
  audioRef,
  timeProgress,
  setTimeProgress,
  duration,
}) => {
  const { isNotAuthorized } = useAuth()

  const handleProgressChange = () => {
    if (!progressBarRef.current || !audioRef.current) return

    const value = +progressBarRef.current.value

    audioRef.current.currentTime = value
    setTimeProgress(value)
    progressBarRef.current.style.setProperty('--range-progress', getPercent(value, duration))
  }

  const memoizedDuration = useMemo(() => formatTime(duration), [duration])
  const timeProgressParsed = formatTime(timeProgress)

  return (
    <div
      className={clsx(commonStyle.progress, {
        [commonStyle.disabled]: isNotAuthorized,
      })}
    >
      <input
        type="range"
        ref={progressBarRef}
        max={duration}
        className={style.progressBar}
        defaultValue="0"
        onChange={handleProgressChange}
      />
      <div className={commonStyle.timeWrapper}>
        <span className={commonStyle.time}>{timeProgressParsed}</span>
        <span className={commonStyle.time}>{memoizedDuration}</span>
      </div>
    </div>
  )
}

export default ProgressBar
